export const SET_REACT_BOUNDARY_ERROR_NOTIFICATION = 'SET_REACT_BOUNDARY_ERROR_NOTIFICATION';

export const setReactBoundaryErrorNotificationAction = payload => ({
  type: SET_REACT_BOUNDARY_ERROR_NOTIFICATION,
  payload
});
